import { createSelector } from 'reselect'
import { createCommunicationSelectors } from 'src/helpers/redux'

import { IState, TGlobalStateWithService } from './state'
import { actions, PREFIX } from './actions'

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX].data

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectors = {
  settings: createSelector(selectData, (state) => state.settings),
  timeZone: createSelector(
    selectData,
    (state) => state.settings.timeZone || undefined
  ),
}

export type Selectors = typeof selectors
